import React from 'react'
import FAQ from '#src/components/FAQ'
import styles from './styles.css'

const ExperienceFAQ: React.SFC = () => {
  return (
    <div className={styles.faq}>
      <FAQ faqSlug="charters-faq-v1" trimLength={3} />
    </div>
  )
}

export default ExperienceFAQ
